import type { ArtBook } from '../definitions/ArtBook'
import type { QueryBookResult } from '../services/book'

export function queryBookResultToArtBook(result: QueryBookResult): ArtBook {
  const generatedPages = new Map(result.pages.map(page => [page.pageNumber, page]))
  const pages = Array.from({ length: result.metadata.themePageCount }, (_, index) => {
    const pageNumber = index + 1
    const generated = generatedPages.get(pageNumber)
    return generated
      ? { ...generated, generateState: 'success' as const, isActive: generated.isActive ?? true }
      : { pageNumber, generateState: 'failed' as const, generationUuid: '', generatedImageUrl: '', isActive: true }
  })
  return { cover: result.cover, metadata: result.metadata, pages, createAt: new Date(result.createTime * 1000), revision: result.revision }
}

export function hasEveryGeneratedPage(book: ArtBook, pageNumbers: number[]): boolean {
  const generatedPageNumbers = new Set(book.pages.filter(page => page.generatedImageUrl).map(page => page.pageNumber))
  return pageNumbers.every(pageNumber => generatedPageNumbers.has(pageNumber))
}
